/* SIZESOFTX
=========================================================================================
* Descripción: Menú de acciones del catálogo de Proveedores
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador             | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1        | 14/05/2026 | Lic. José Luis Aragón Cervantes  | Creación
*      2        | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en acciones críticas
* ---------------------------------------------------------------------------------------
*/

import { Fragment } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';
import SearchIcon from '@mui/icons-material/Search';

import SizeSoftXModal from "../../leyout/SizeSoftXModal.jsx";

import { useProveedores } from "../../../context/Catalogos/ProveedoresContext";
import { useDoubleClickPrevention } from "../../../hooks/useDoubleClickPrevention";

export default function MnuProveedoresActions({ onGuardar }) {
    const {
        handleClickRegresarMainDashboard,
        handleClickNuevoProveedor,
        handleClickEditarProveedor,
        handleClickGuardarProveedor,
        handleClickEliminarProveedor,
        handleClickDeshacer,
        statusEditProveedor,
        setStatusEditProveedor,
        statusOpenModalEliminarProveedor,
        setStatusOpenModalEliminarProveedor,
        handleOpenModalBuscarProveedor,
        proveedorSeleccionado,
    } = useProveedores();
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    const hayProveedorCargado = proveedorSeleccionado && proveedorSeleccionado.claveproveedor && proveedorSeleccionado.claveproveedor.toString().trim() !== "";

    const handleGuardar = () => {
        if (onGuardar) {
            onGuardar();
        } else {
            handleClickGuardarProveedor();
        }
    };

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Buscar Proveedor (Alt+F1)'}>
                <IconButton onClick={handleOpenModalBuscarProveedor}>
                    <SearchIcon className="icon" /><p className="icon">Buscar</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Nuevo'}>
                <IconButton disabled={isProcessing || !statusEditProveedor} onClick={() => executeWithProtection(handleClickNuevoProveedor)}>
                    <AddIcon className="icon" /><p className="icon">Nuevo</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Guardar'}>
                <IconButton disabled={isProcessing || statusEditProveedor} onClick={() => executeWithProtection(handleGuardar)}>
                    <SaveIcon className="icon" /><p className="icon">Guardar</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Editar'}>
                <IconButton disabled={isProcessing || !statusEditProveedor || !hayProveedorCargado} onClick={() => executeWithProtection(handleClickEditarProveedor)}>
                    <EditIcon className="icon" /><p className="icon">Editar</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Eliminar'}>
                <IconButton disabled={isProcessing || statusEditProveedor || !hayProveedorCargado} onClick={() => executeWithProtection(() => setStatusOpenModalEliminarProveedor(true))}>
                    <DeleteIcon className="icon" /><p className="icon">Eliminar</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Deshacer'}>
                <IconButton disabled={isProcessing || statusEditProveedor} onClick={() => executeWithProtection(handleClickDeshacer)}>
                    <UndoIcon className="icon" /><p className="icon">Deshacer</p>
                </IconButton>
            </Tooltip>

            <SizeSoftXModal
                open={statusOpenModalEliminarProveedor}
                title={"¿Está seguro de querer eliminar el proveedor? Esta acción no se puede deshacer."}
                onClose={() => setStatusOpenModalEliminarProveedor(false)}
                onSuccess={() => executeWithProtection(handleClickEliminarProveedor)}
                success="Eliminar"
            />
        </Fragment>
    );
}
